<div class="tcf">
  <header class="tcf-header">
    <h2>{{ user.displayName || user.userName || user.emailAddress }}</h2>
  </header>

  <div class="tcf-body">
    <section class="ud-section">
      <div class="ud-section-head">
        <span class="ud-section-title">Account details</span>
        <div class="ud-actions" *ngIf="auth.hasPermission('User.Manage')">
          <button type="button" class="ud-link br-btn br-btn--link br-btn--sm" [disabled]="resettingPassword" (click)="confirmPasswordReset()">
            {{ resettingPassword ? 'Sending…' : 'Reset password' }}
          </button>
          <button type="button" class="ud-link br-btn br-btn--link br-btn--sm" (click)="openEdit()">Edit</button>
        </div>
      </div>
      <dl class="ud-list">
        <div class="ud-item"><dt>Name</dt><dd>{{ user.displayName || '—' }}</dd></div>
        <div class="ud-item"><dt>Email</dt><dd>{{ user.emailAddress }}</dd></div>
        <div class="ud-item"><dt>Username</dt><dd>{{ user.userName || '—' }}</dd></div>
        <div class="ud-item">
          <dt>Status</dt>
          <dd><span class="tag br-badge" [class.tag-muted]="!user.canLogin" [class.br-badge--neutral]="!user.canLogin">{{ user.canLogin ? 'Active' : 'Disabled' }}</span></dd>
        </div>
      </dl>
    </section>

    <section class="ud-section">
      <div class="ud-section-head">
        <span class="ud-section-title">Roles</span>
        <button type="button" class="ud-link br-btn br-btn--link br-btn--sm" *ngIf="canManageRoles" (click)="openAssignRole()">Assign role</button>
      </div>
      <div class="ud-roles" *ngIf="user.roles.length">
        <span class="role-pill" *ngFor="let r of user.roles">
          {{ r }}
          <button type="button" class="role-remove" *ngIf="canManageRoles"
                  title="Remove role" (click)="confirmRemoveRole(r)">
            <br-icon>close</br-icon>
          </button>
        </span>
      </div>
      <div class="ud-empty" *ngIf="!user.roles.length">No roles assigned</div>
    </section>
  </div>

  <footer class="tcf-actions">
    <button type="button" class="br-btn br-btn--ghost" (click)="back()">Close</button>
  </footer>
</div>
